import { render, staticRenderFns } from "./SquareMetersPriceTypeCard.vue?vue&type=template&id=501f0cfb&"
import script from "./SquareMetersPriceTypeCard.vue?vue&type=script&lang=js&"
export * from "./SquareMetersPriceTypeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports